<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">My Team Leaves</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Leaves</li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Status
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" @click="getEmployeeLeaves">All</a>
                  <a class="dropdown-item" @click="getEmployeeNewLeaves">New</a>
                  <a class="dropdown-item" @click="getEmployeeApprovedLeaves"
                    >Approved</a
                  >
                  <a class="dropdown-item" @click="getEmployeeRejectedLeaves"
                    >Rejected</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="employeeLeaves"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.fromDate`]="{ item }">
                    {{
                      item.fromDate
                        ? new Date(item.fromDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.toDate`]="{ item }">
                    {{
                      item.toDate
                        ? new Date(item.toDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setLeaveStatus(item)"
                          v-if="item.status == 0 && item.nextApproval"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        >
                        <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'leavehistory',
                          params: { id: item.employee.id }
                        }"> View History</router-link>
                        <a
                          class="dropdown-item"
                          @click="amendEmployeeLeaveByHOD(item)"
                          v-if="item.status == 1"
                          ><i class="fa fa-pencil m-r-5"></i> Amend Employee
                          Leave</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <div class="avatar">
                        <img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"
                        />
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                        />
                      </div>
                      <div>
                        {{
                          `${item.employee.firstName} ${item.employee.lastName}`
                        }}
                      </div>
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <!-- <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a> -->

                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="!item.nextApproval && item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
          <!-- Approve Leave Modal -->
          <v-dialog v-model="dialogStatus" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button type="button" class="close" @click="closeStatus">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Leave Approve</h3>
                  <p>Are you sure want to approve for this leave?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="changeLeaveStatus(1)"
                        class="btn btn-primary continue-btn"
                        >Approve</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        @click="changeLeaveStatus(2)"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Decline</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Approve Leave Modal -->

          <!-- Leave Amendment Modal -->
          <v-dialog v-model="dialogAmendLeave" max-width="350px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Leave Amendment</h5>
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="amendEmployeeLeaveRequestByHOD">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label">Leave End Date </label>

                        <datepicker
                          v-model="leave.toDate"
                          calendar-class
                          input-class
                          bootstrap-styling
                          class="form-control datetimepicker"
                          type="text"
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label"> New Amend Date </label>
                        <datepicker
                          v-model="newReturningLeaveDate"
                          calendar-class
                          input-class
                          bootstrap-styling
                          class="form-control datetimepicker"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label"
                          >Reasons for Leave Amendment</label
                        >

                        <textarea v-model="newHODReasons" class="textarea-box">
                        </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn" type="submit">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Leave Amendment Modal -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      leaveReduce: "",
      dialog: false,
      dialogEdit: false,
      dialogAmendLeave: false,
      dialogStatus: false,
      dialogDelete: false,
      media: "data:image/jpeg;base64,",
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "LeaveType", value: "leaveType.name" },
        { text: "From", value: "fromDate" },
        { text: "To", value: "toDate" },
        { text: "No of Days", value: "days" },
        { text: "Reason", value: "reason" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      leaveTypeId: 0,
      days: 0,
      leave: {},
      employeeLeaves: [],
      employeeLeave: {},
      leaves: [],
      leaveTypes: [],
      fromDate: "",
      toDate: "",
      eligibileDays: 0,
      reason: "",
      employeeId: 0,
      employees: [],
      employee: {},
      totalEmployees: 0,
      totalAbsence: 0,
      totalPendingLeave: 0,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      fullName: "",
      error: "",
      message: "",
      daysInterval: "",
      status: "",
      newHODReasons: "",
      newReturningLeaveDate: "",
      requestedDate: new Date()
    };
  },

  watch: {
    dialogStatus(val) {
      val || this.closeStatus();
    }
  },

  methods: {
    closeStatus() {
      this.dialogStatus = false;
    },
    close() {
      this.dialogAmendLeave = false;
      this.clearData();
    },
    clearData() {
      this.newReturningLeaveDate = "";
      this.newHODReasons = "";
      this.requestedDat = "";
    },

    setLeaveStatus(item) {
      this.leave = item;
      this.dialogStatus = true;
      // console.log(`item`, item)
    },
    amendEmployeeLeaveByHOD(item) {
      this.leave = item;
      this.dialogAmendLeave = true;

      this.fullName =
        this.currentUser.employee.firstName +
        " " +
        this.currentUser.employee.lastName;
      // console.log(`item`, item);
    },

    amendEmployeeLeaveRequestByHOD() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService
        .addEmployeeAmedLeave(
          unit.id,
          this.leave.id,
          this.newReturningLeaveDate,
          this.newHODReasons,
          this.currentUser.employee.id,
          this.requestedDate
        )
        .then(() => {
          this.close();
        });
    },
    setLeave(item) {
      this.employeeLeave = item;
    },
    changeLeaveStatus(status) {
      var designation = this.currentUser.employee.designation.name;
      this.submitted = true;
      const id = this.leave.id;
      var req = { employeeLeaveId: this.leave.id, approvalEmployeeId: this.currentUser.employee.id, approvedDate: new Date(), approved: (status === 1) ? true : false}
      this.loading = true;
      employeeService.approveEmployeeLeave(req).then(
        id => {
          employeeService
            .getEmployeeLeavesByManager(
              this.currentUser.employee.id
            )
            .then(o => {
              this.employeeLeaves = o.filter(
                c => c.status == 0
              );
              this.closeStatus();
              this.getEmployeeLeaves();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getEmployeeLeaves() {
      employeeService
        .getEmployeeLeavesByManager(
              this.currentUser.employee.id
        )
        .then(
          model => {
            this.employeeLeaves = model.filter(
              c => c.status == 0
            );
            // console.log("leaves:", model[0]);
          },
          error => {
            error = error;
          }
        );
    },
    getEmployeeNewLeaves() {
      employeeService
        .getEmployeeLeavesByManager(
              this.currentUser.employee.id
        ).then(
        model => {
          this.employeeLeaves = model.filter(
            c => c.status == 0
          );
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeApprovedLeaves() {
      employeeService
        .getEmployeeLeavesByManager(
              this.currentUser.employee.id
        ).then(
        model => {
          this.employeeLeaves = model.filter(c => c.status == 1);
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },
    getEmployeeRejectedLeaves() {
      employeeService
        .getEmployeeLeavesByManager(
              this.currentUser.employee.id
        ).then(
        model => {
          this.employeeLeaves = model.filter(c => c.status == 2);
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    }
    // setLeaveType() {
    //   this.leaveType = this.leaveTypes.map((a) => a);
    //   //console.log(this.leaveType)
    // },
  },
  mounted() {
    this.getEmployeeLeaves();
    //this.setDaysInterval()
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/leaves/leavesByManagerHR.vue